module.exports = __webpack_public_path__ + "media/images/icons/outlined/left-circle-976fda06bf9213029c8230ee368c3445.svg";